<template>
    <a @click="toggleValidated">
        {{ this.isValidated ? this.setUnvalidateLabel : this.setValidateLabel }}
    </a>
</template>

<script>
    export default {
        props: {
            subscription: String,
            initialIsValidated: Boolean,
            setValidateLabel: String,
            setUnvalidateLabel: String,
            route: String,
            setValidatedHandler: Function,
        },
        data: function () {
            return {
                isValidated: this.initialIsValidated
            }
        },
        methods: {
            setValidated() {
                this.setValidatedHandler(this.subscription, this.isValidated);
            },
            toggleValidated () {
                if(this.route) {
                    axios.post(this.route, {
                        'item' : this.subscription,
                        'notification_mode': 'none'
                    }).then(response => {
                        this.isValidated = response.data.is_on;
                        this.setValidated()
                    }).catch(function (error) {
                        // error management?
                        console.log(error);
                    });
                }
            }
        },
        mounted: function() {
            this.setValidated()
        }
    };
</script>
